import React from 'react';
import ReactDOM from 'react-dom/client';
import './index.scss';
import App from 'components/App';
import reportWebVitals from './reportWebVitals';
import { BrowserRouter } from 'react-router-dom';
import "./services/axiosSetup";

const root = ReactDOM.createRoot(document.getElementById('root'));

root.render(
    <BrowserRouter>
        <App />
    </BrowserRouter>
);

reportWebVitals();